"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Field = Field;
exports.FieldContent = FieldContent;
exports.FieldDescription = FieldDescription;
exports.FieldError = FieldError;
exports.FieldGroup = FieldGroup;
exports.FieldLabel = FieldLabel;
exports.FieldLegend = FieldLegend;
exports.FieldSeparator = FieldSeparator;
exports.FieldSet = FieldSet;
exports.FieldTitle = FieldTitle;
var _react = require("react");
var _classVarianceAuthority = require("class-variance-authority");
var _utils = require("@design/lib/utils");
var _label = require("@design/ui/label");
var _separator = require("@design/ui/separator");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className"],
  _excluded2 = ["className", "variant"],
  _excluded3 = ["className"],
  _excluded4 = ["className", "orientation"],
  _excluded5 = ["className"],
  _excluded6 = ["className"],
  _excluded7 = ["className"],
  _excluded8 = ["className"],
  _excluded9 = ["children", "className"],
  _excluded0 = ["className", "children", "errors"];
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function FieldSet(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("fieldset", _objectSpread(_objectSpread({
    "data-slot": "field-set",
    className: (0, _utils.cn)("flex flex-col gap-6 has-[>[data-slot=checkbox-group]]:gap-3 has-[>[data-slot=radio-group]]:gap-3", className)
  }, props), {}, {
    "data-sentry-component": "FieldSet",
    "data-sentry-source-file": "field.tsx"
  }));
}
function FieldLegend(_ref2) {
  var className = _ref2.className,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? "legend" : _ref2$variant,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("legend", _objectSpread(_objectSpread({
    "data-slot": "field-legend",
    "data-variant": variant,
    className: (0, _utils.cn)("mb-3 font-medium data-[variant=label]:text-sm data-[variant=legend]:text-base", className)
  }, props), {}, {
    "data-sentry-component": "FieldLegend",
    "data-sentry-source-file": "field.tsx"
  }));
}
function FieldGroup(_ref3) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "field-group",
    className: (0, _utils.cn)("group/field-group @container/field-group flex w-full flex-col gap-7 data-[slot=checkbox-group]:gap-1 data-[slot=checkbox-group]:*:data-[slot=field]:gap-2 data-[slot=checkbox-group]:*:data-[slot=field]:p-3 *:data-[slot=field-group]:gap-4", className)
  }, props), {}, {
    "data-sentry-component": "FieldGroup",
    "data-sentry-source-file": "field.tsx"
  }));
}
var fieldVariants = (0, _classVarianceAuthority.cva)("group/field flex w-full gap-2 data-[invalid=true]:text-destructive", {
  variants: {
    orientation: {
      vertical: "flex-col *:w-full [&>.sr-only]:w-auto",
      horizontal: "flex-row items-center has-[>[data-slot=field-content]]:items-start *:data-[slot=field-label]:flex-auto has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px",
      responsive: "flex-col *:w-full @md/field-group:flex-row @md/field-group:items-center @md/field-group:*:w-auto @md/field-group:has-[>[data-slot=field-content]]:items-start @md/field-group:*:data-[slot=field-label]:flex-auto [&>.sr-only]:w-auto @md/field-group:has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px"
    }
  },
  defaultVariants: {
    orientation: "vertical"
  }
});
function Field(_ref4) {
  var className = _ref4.className,
    _ref4$orientation = _ref4.orientation,
    orientation = _ref4$orientation === void 0 ? "vertical" : _ref4$orientation,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    role: "group",
    "data-slot": "field",
    "data-orientation": orientation,
    className: (0, _utils.cn)(fieldVariants({
      orientation: orientation
    }), className)
  }, props), {}, {
    "data-sentry-component": "Field",
    "data-sentry-source-file": "field.tsx"
  }));
}
function FieldContent(_ref5) {
  var className = _ref5.className,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "field-content",
    className: (0, _utils.cn)("group/field-content flex flex-1 flex-col gap-1 leading-snug", className)
  }, props), {}, {
    "data-sentry-component": "FieldContent",
    "data-sentry-source-file": "field.tsx"
  }));
}
function FieldLabel(_ref6) {
  var className = _ref6.className,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_label.Label, _objectSpread(_objectSpread({
    "data-slot": "field-label",
    className: (0, _utils.cn)("group/field-label peer/field-label flex w-fit gap-2 group-data-[disabled=true]/field:opacity-50 has-data-checked:card-selected has-[>[data-slot=field]]:rounded-lg has-[>[data-slot=field]]:border has-[>[data-slot=field]]:border-input has-[>[data-slot=field]]:not-has-[:disabled,[data-disabled]]:hover:bg-muted/50 has-[>[data-slot=field]]:has-[:focus-visible]:border-ring has-[>[data-slot=field]]:has-[:focus-visible]:ring-3 has-[>[data-slot=field]]:has-[:focus-visible]:ring-ring/50 *:data-[slot=field]:p-3", "has-[>[data-slot=field]]:w-full has-[>[data-slot=field]]:flex-col", className)
  }, props), {}, {
    "data-sentry-element": "Label",
    "data-sentry-component": "FieldLabel",
    "data-sentry-source-file": "field.tsx"
  }));
}
function FieldTitle(_ref7) {
  var className = _ref7.className,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "field-label",
    className: (0, _utils.cn)("flex w-fit items-center gap-2 text-sm font-medium group-data-[disabled=true]/field:opacity-50", className)
  }, props), {}, {
    "data-sentry-component": "FieldTitle",
    "data-sentry-source-file": "field.tsx"
  }));
}
function FieldDescription(_ref8) {
  var className = _ref8.className,
    props = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", _objectSpread(_objectSpread({
    "data-slot": "field-description",
    className: (0, _utils.cn)("fit-wrap text-left text-sm leading-normal font-normal text-muted-foreground group-has-data-horizontal/field:text-balance [[data-variant=legend]+&]:-mt-1.5", "last:mt-0 nth-last-2:-mt-1", "[&>a]:underline [&>a]:underline-offset-4 [&>a:hover]:text-primary", className)
  }, props), {}, {
    "data-sentry-component": "FieldDescription",
    "data-sentry-source-file": "field.tsx"
  }));
}
function FieldSeparator(_ref9) {
  var children = _ref9.children,
    className = _ref9.className,
    props = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
    "data-slot": "field-separator",
    "data-content": !!children,
    className: (0, _utils.cn)("relative -my-2 h-5 text-sm group-data-[variant=outline]/field-group:-mb-2", className)
  }, props), {}, {
    "data-sentry-component": "FieldSeparator",
    "data-sentry-source-file": "field.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_separator.Separator, {
      className: "absolute inset-0 top-1/2",
      "data-sentry-element": "Separator",
      "data-sentry-source-file": "field.tsx"
    }), children && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "relative mx-auto block w-fit bg-background px-2 text-muted-foreground",
      "data-slot": "field-separator-content",
      children: children
    })]
  }));
}
function FieldError(_ref0) {
  var className = _ref0.className,
    children = _ref0.children,
    errors = _ref0.errors,
    props = _objectWithoutProperties(_ref0, _excluded0);
  var content = (0, _react.useMemo)(function () {
    if (children) {
      return children;
    }
    if (!(errors !== null && errors !== void 0 && errors.length)) {
      return null;
    }
    var uniqueErrors = _toConsumableArray(new Map(errors.map(function (error) {
      return [error === null || error === void 0 ? void 0 : error.message, error];
    })).values());
    if ((uniqueErrors === null || uniqueErrors === void 0 ? void 0 : uniqueErrors.length) == 1) {
      var _uniqueErrors$;
      return (_uniqueErrors$ = uniqueErrors[0]) === null || _uniqueErrors$ === void 0 ? void 0 : _uniqueErrors$.message;
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      className: "ml-4 flex list-disc flex-col gap-1",
      children: uniqueErrors.map(function (error, index) {
        return (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          children: error.message
        }, index);
      })
    });
  }, [children, errors]);
  if (!content) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    role: "alert",
    "data-slot": "field-error",
    className: (0, _utils.cn)("text-sm font-normal text-destructive", className)
  }, props), {}, {
    "data-sentry-component": "FieldError",
    "data-sentry-source-file": "field.tsx",
    children: content
  }));
}